import React, { MouseEventHandler, useCallback, useState } from 'react';
import jpgFile from '../../assets/icons/jpg-file.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/download-attachment2.svg';
import FileInput from '../FileInput.component';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { useStyles } from './FileDragAndDrop.styles';
import { CircularProgress } from '@material-ui/core';
import { downloadFileRawDataAsync } from '../../utils/downloadRawFile';

export interface propsFileDradAndDrop {
  handleFilesUpload: (files: FileList) => void;
  handleRemoveFile: MouseEventHandler<HTMLSpanElement> | undefined;
  ruleFile: File | undefined;
  fileName: string | undefined;
  fileSize: number | undefined;
  isEditMode: boolean;
  id: string;
  link: string;
  acceptedExtension: string[];
  isFileLoader?: boolean;
}

function formatFileSize(bytes: number | undefined, si = true, dp = 2) {
  const thresh = si ? 1000 : 1024;
  if (!bytes) return '';
  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = si
    ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

  return bytes.toFixed(dp) + ' ' + units[u];
}

const FileDragAndDrop: React.FC<propsFileDradAndDrop> = (props) => {
  const classes = useStyles();
  const [fileDetailsTooltipVisible, setFileDetailsTooltipVisible] = useState<boolean>(false);

  const removeFile = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    const input = document.querySelector('input[type="file"]')  as HTMLInputElement | null;
    if (input) {
      input.value = '';
    }
    if(props.handleRemoveFile){
      props.handleRemoveFile(e);
    }
  }

  const handleTooltipDisplay = useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.currentTarget.offsetWidth < e.currentTarget.scrollWidth) {
      setFileDetailsTooltipVisible(true);
    }
  }, []);

  const onDownloadClick = () => {
    if (!props.ruleFile || !props.fileName) return;
    downloadFileRawDataAsync(`${props.fileName}`, props.ruleFile);
  };

  return (
    <>
      {props.isEditMode && (
        <>
          <div className={classes.subHeader}>Zasady oceniania</div>
          <div className={classes.dragAndDropZone}>
            <FileInput onFilesLoaded={props.handleFilesUpload} acceptedFileExtensions={props.acceptedExtension} />
          </div>
        </>
      )}
      <div className={classes.subHeader}>Załączone pliki:</div>
      <div className={classes.fileName} onClick={(e) => e.preventDefault()}>
        {!props.ruleFile && !props.isFileLoader && <span>Brak</span>}
        {props.isFileLoader && !props.ruleFile && (
          <CircularProgress size={25} style={{ verticalAlign: 'middle', marginLeft: '50%', color: '#3C419A' }} />
        )}
        {props.ruleFile && (
          <div key={props.fileName} className={!props.isEditMode ? classes.file : classes.fileEdit}>
            {!props.isEditMode ? (
              <Link href={props.link} style={{ cursor: 'default' }}>
                <img src={jpgFile} className={classes.jpgFile} alt="ikona pliku" />
              </Link>
            ) : (
              <img src={jpgFile} className={classes.jpgFile} alt="ikona pliku" />
            )}
            <div className={classes.fileDetailsContainer}>
              <TooltipOne
                title={props.fileName ? props.fileName : '-'}
                open={fileDetailsTooltipVisible}
                placement="top"
              >
                <div
                  className={classes.fileDetails}
                  onMouseOver={handleTooltipDisplay}
                  onMouseLeave={() => setFileDetailsTooltipVisible(false)}
                >
                  {props.fileName}
                  <div className={classes.fileSize}>{formatFileSize(props.fileSize)}</div>
                </div>
              </TooltipOne>
              {!props.isEditMode && (
                <TooltipOne title="Pobierz plik" placement="top">
                  <Button
                    className={classes.downloadFileButton}
                    aria-label="Ikona pobrania pliku"
                    onClick={() => onDownloadClick()}
                  >
                    <DownloadIcon className={classes.downloadFileIcon} />
                  </Button>
                </TooltipOne>
              )}
            </div>
            {props.isEditMode && (
              <span className={classes.fileRemove} onClick={(e) => removeFile(e)}>
                &#x2715;
              </span>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default FileDragAndDrop;
